<template>
  <div class="management-com">
    <div class="search_condition flex-row justify-end">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="发起时间：">
          <el-date-picker
            @change="changeDate"
            v-model="formInline.time"
            class="dataTimer"
            type="daterange"
            size="medium"
            range-separator="-"
            prefix-icon="el-icon-date"
            popper-class="dateTimer-droper"
            :clearable="true"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <!--
        <el-form-item>
          <el-button @click="getListInfo" class="select-btn" plain>查询</el-button>
        </el-form-item>
				-->
      </el-form>
    </div>
    <el-table
      border
      :data="tableData"
      :row-style="{ height: '50px', fontSize: '14px' }"
      :cell-style="{ padding: 0 }"
      :header-row-style="tableHeaderRow"
      :header-cell-style="tableHeaderColor"
      v-loading="loading"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" type="index" width="60"> </el-table-column>
      <el-table-column prop="match_title" label="关联直播" align="center" :show-overflow-tooltip="true"> </el-table-column>
      <el-table-column prop="live_title" label="直播标题" align="center" :show-overflow-tooltip="true"> </el-table-column>
      <el-table-column prop="sender_name" label="问题&选填" width="190px" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
          <br />
          <div>A.{{ scope.row.contentArr[0] }} VS B.{{ scope.row.contentArr[1] }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="发起/封盘时间" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div class="padding-tb-20">
            <div>{{ scope.row.create_time }}</div>
            <div>-</div>
            <div v-if="scope.row.status == 1">{{ scope.row.end_time }}</div>
            <div v-else>{{ scope.row.close_time }}</div>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="total_people" label="参与人数" align="center" :show-overflow-tooltip="true"> </el-table-column>

      <el-table-column label="总奖池" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div>{{ Number(scope.row.pot / 100).toFixed(2) }}</div>
        </template>
      </el-table-column>

      <el-table-column label="状态" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <template v-if="scope.row.status == 1">
            <span v-if="scope.row.endTime > new Date()" style="color: #02a8a2"> 进行中 </span>
            <span v-else style="color: #999999">待开奖</span
            ><!-- 已结束 -->
          </template>

          <span v-else-if="scope.row.status == 2" style="color: #999999">待开奖</span
          ><!-- 已结束 -->
          <span v-else-if="scope.row.status == 3" style="color: #999999">已取消</span>
          <span v-else-if="scope.row.status == 4" style="color: #999999">已开奖</span>
          <span v-else-if="scope.row.status == 5" style="color: #999999">开奖后取消</span>
          <span v-else-if="scope.row.status == 6" style="color: #999999">已取消</span>
        </template>
      </el-table-column>

      <el-table-column label="封盘倒计时" align="center" width="110px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <CountDown v-if="scope.row.status == 1 && scope.row.endTime > new Date()" beforeTimeContent="剩余" :endTime="scope.row.endTime"></CountDown>
          <div v-else>已封盘</div>
        </template>
      </el-table-column>
      <el-table-column prop="resultStr" label="开奖结果" align="center" :show-overflow-tooltip="true"> </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <div class="handler-panel flex-middle">
            <template v-if="scope.row.status == 1">
              <div v-if="scope.row.endTime > new Date()" class="handler-btn" @click="handlerDown(scope.row)">封盘</div>
              <div v-if="scope.row.status == 2" class="handler-btn" @click="handlerOpen(scope.row)">开奖</div>
            </template>

            <div v-else-if="scope.row.status == 2" class="handler-btn" @click="handlerOpen(scope.row)">开奖</div>
            <div v-else>-</div>
          </div>
        </template>
      </el-table-column>

      <div slot="empty" class="search_list">
        <div class="list_body">
          <div class="empty_content">
            <!-- <img src="https://test-1301875615.cos.ap-beijing.myqcloud.com/images/20211013094041773982020-12-15%2021.33.14.jpg"
			             alt="" />
			        <div class="empty_text">暂无任何记录哦～</div>
			        -->
            <Empty text="暂时没有数据" :imgWidth="250" :img="require('@/assets/img/empty/consume.png')"></Empty>
          </div>
        </div>
      </div>
    </el-table>
    <div class="pagination_bottom">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="info.size"
        :total="totalCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="info.page"
      >
      </el-pagination>
      <DownDialog ref="DownDialog" @commit="closeGuess" commitContent="封盘" :title="countDialogTitle"></DownDialog>
      <OpenRewardDialog ref="OpenRewardDialog" @refresh="getListInfo()"></OpenRewardDialog>
    </div>
  </div>
</template>

<script>
import { post } from "../../util/http";
import { mapState } from "vuex";
import moment from "moment";
import Empty from "@/components/empty/empty";
import CountDown from "@/components/count-down/CountDown";
import DownDialog from "@/components/dialog/AlertDialog";
import OpenRewardDialog from "@/components/dialog/OpenRewardDialog";
export default {
  components: {
    Empty,
    CountDown,
    DownDialog,
    OpenRewardDialog,
  },
  data() {
    return {
      moment: moment,
      loading: false,
      formInline: {
        time: [],
      },
      tableData: [],
      info: {
        page: 1,
        size: 8,
      },
      totalCount: 0,
      countDialogTitle: "",
    };
  },
  props: {
    live_id: {
      type: [Number, String],
      default: "",
    },
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    console.log(this.userInfo);
  },
  mounted() {
    this.$nextTick(() => {
      this.getListInfo();
      let keyNode = document.querySelector(".el-date-editor");
      console.log(keyNode);
      if (!keyNode) return;
      /*
			let iNode = document.createElement("i");
			iNode.setAttribute("class", "el-icon-date"); // el-icon-bottom
			keyNode.appendChild(iNode);

			iNode.style.position = "absolute";
			iNode.style.top = "13px";
			iNode.style.right = "13px";
			*/
      // this.getListInfo();
    });
  },
  filters: {
    formatData: (value) => {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      let m = date.getMinutes();
      let s = date.getSeconds();
      h = h < 10 ? "0" + h : h;
      m = m < 10 ? "0" + m : m;
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + "" + h + ":" + m + ":" + s;
    },
  },
  methods: {
    changeDate() {
      this.getListInfo();
    },
    handleSizeChange(val) {
      this.$set(this.info, "size", val);
      // console.log(`每页 ${val} 条`);
      this.selectList();
    },
    handleCurrentChange(val) {
      this.$set(this.info, "page", val);
      //console.log(`当前页: ${val}`);
      this.getListInfo();
    },
    getListInfo() {
      this.loading = true;
      let data = {
        //"category_id": 0,
        // "live_id": this.live_id,
        page: this.info.page,
        // "q_id": 0,
        size: this.info.size,
        status: 0,
      };
      if (this.formInline.time && this.formInline.time.length) {
        //data.t_end = String(new Date(this.formInline.time[1]).getTime() / 1000) || "";
        //data.t_start = String(new Date(this.formInline.time[0]).getTime() / 1000) || "";
        data.t_end = this.formInline.time[1] + " 23:59:59" || "";
        data.t_start = this.formInline.time[0] + " 00:00:00" || "";
      }
      // console.log(data)
      post({
        url: "/api/guess/getGuessList",
        data,
      })
        .then(({ data: { data } }) => {
          const list = data.guess || [];
          list.forEach((v) => {
            if (v.end_time) {
              v.endTime = new Date(v.end_time);
            } else {
              v.endTime = "";
            }
            if (v.close_time) {
              v.closeTime = new Date(v.close_time);
            } else {
              v.closeTime = "";
            }
            v.contentArr = v.content?.split("|") || ["", ""];
            v.result = v.result || 0;
            v.resultStr = "";
            if (v.result > 0) {
              v.resultStr = v.contentArr[v.result - 1];
            }
          });
          console.log("list: ", list);
          this.tableData = list;
          this.totalCount = data.total || 0;
          setTimeout(() => {
            this.loading = false;
          }, 20);
          // this.$emit('backCount', data.count)
        })
        .catch((err) => {
          setTimeout(() => {
            this.loading = false;
          }, 20);
        });
    },
    // 设置表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // return 'background-color: #c7e7e2;color:#526e6e;font-size: 14px;font-weight:600; height: 36px;padding: 0px'
      return `
				background-color:#02A8A2;
				color:#ffffff;
				font-size: 14px;
				font-weight:600; 
				height: 36px;
				padding: 0px";
				border : 0px;
			 `;
    },
    tableHeaderRow() {
      //return 'height: 36px'
      return `
				height:56px;
				letter-spacing:1px;
				border-radius : 20px;
			`;
    },
    // handleSizeChange(val) {
    // 	console.log(`每页 ${val} 条`);
    // },
    // handleCurrentChange(val) {
    // 	console.log(`当前页: ${val}`);
    // }

    handlerDown(item = {}) {
      let { title = "", contentArr = ["", ""] } = item;
      this.countDialogTitle = `
				<div>
					<span>${title}</span>
					<span>A.${contentArr[0]}</span>
					<span>B.${contentArr[1]}</span>
				</div>
				`;
      this.$refs.DownDialog.open(item);
    },

    closeGuess({ g_id = "" }) {
      if (!g_id) {
        return;
      }
      let data = {
        anchor_id: this.userInfo.id,
        g_id,
      };
      // console.log(data)
      post({
        url: "/api/guess/closeGuess",
        data,
      })
        .then(({ data: { data, status = "" } }) => {
          if (status == 0) {
            this.$message({
              message: "封盘成功",
              type: "success",
              customClass: "ly-success",
            });
            this.getListInfo();
          } else {
            this.$message({
              message: "封盘失败",
              type: "error",
              customClass: "ly-error",
            });
          }
        })
        .catch((err) => {
          console.warn("closeGuess err: ", err);
          this.$message({
            message: "封盘失败",
            type: "error",
            customClass: "ly-error",
          });
        });
    },
    handlerOpen(item = {}) {
      this.$refs.OpenRewardDialog.open(item);
    },
  },
};
</script>

<style lang="stylus" scoped>
.management-com{
	/deep/{
		.el-range__close-icon{
			right : 40px !important;
			z-index : 1000;
		}
		.el-range-editor--medium .el-range__close-icon, .el-range-editor--medium .el-range__icon{
			position : absolute;
			right : 10px;
			justify-content: center;
			display: flex;
			align-items: center;
		}
	 .el-icon-date:before {
			content: "";
			background: url(../../assets/img/guessing-management/date.png) no-repeat;
			background-size: 100% auto;
			display: block;
			width: 18px;
			height: 18px;
		}
		.el-table{
			// border : 0px;
			border-top-left-radius: 13px;
			border-top-right-radius: 13px;
		}
		.el-pagination{
			padding : 30px 0px;
		}
		.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
			color : #02A8A2;
			background : #ffffff;
			border : 1px solid #DBDBDB;
		}
		.el-pagination.is-background .el-pager li:not(.disabled).active{
			background : #02A8A2;
			color : #ffffff;
			border-color : #02A8A2;
		}
	}
	.handler-panel{
		img {
			height : 17px;
			margin : 0px 5px;
		}
		 .handler-btn{
			 background: #02A8A2;
			 border-radius: 2px;
				padding : 4px 15px;
				color : #ffffff;
				cursor : pointer;
		 }
	}
	.pagination_bottom {
			padding: 10px;
			display: flex;
			justify-content: center;
	}
}
.search_list {
  width: 100%;

  /deep/ .empty_content {
    // height: 250px;
  }

  /deep/ .el-table__empty-text {
    width: 100%;
  }

  .list_body {
    height: 444px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .empty_content {
      img {
        width: 136px;
        height: 156px;
        margin-bottom: 39px;
      }

      .empty_text {
        font-size: 14px;
        color: #999;
        text-align: center;
      }
    }
  }
}
</style>
